export const SUPPORTED_VIDEO_FORMATS = [
    'video/mp4',
    'video/quicktime', // for mov
    'video/x-msvideo', // for avi
    'video/x-ms-wmv', // for wmv
    'video/x-flv', // for flv
    'video/x-matroska', // for mkv
    'video/MP2T', // for ts
    'video/vnd.dlna.mpeg-tts', // for m2ts
]

export const SUPPORTED_IMAGE_FORMATS = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
]
